import { createApp } from 'vue';
import App from './App.vue';
import AlgoliaApp from './AlgoliaApp.vue';

// App main
const main = async () => {
    let algoliaContainer = document.getElementById('algoliaContainer');
    if (algoliaContainer) {
        const algoliaApp = createApp(AlgoliaApp);
        algoliaApp.mount('#algoliaContainer');
    }

    let componentContainer = document.getElementById('componentContainer');
    if (componentContainer) {
        const app = createApp(App);
        app.mount('#componentContainer');
    }
};

// Execute async function
main().then( (root) => {
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}